module.exports = require('./helpers/bundle-url').getBundleURL('9p9yL') + "Oswald-Bold.0f6a7ca6.ttf";